// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__KgjHw","withArrow":"menu_withArrow__nbOnw","sm":"menu_sm__I90dZ","inner":"menu_inner__sBCX4"};